import type { Guide } from '../types';

/**
 * S-04.11-02 — prezlecenie ze źródłem Transporeon z transportu, którego nie ma w TMS (paczka przyjęcia
 * zleceń, decyzje Bartka 04.11.2026). Krok pokazuje filtr „Brak w TMS” na ekranie „Transporeon” — tam stoi
 * odnośnik do założonego prezlecenia; nagrywarka niczego nie zapisuje.
 */
export const guide: Guide = {
  flagKey: 'transporeonPreOrders',
  title: 'Transporeon: prezlecenie, gdy brak w TMS',
  whatItDoes:
    'Transport przyjęty w Transporeonie, którego godzinę po przyjęciu nadal nie ma w TMS, dostaje prezlecenie ze źródłem Transporeon: spółka, zleceniodawca, numer transportu jako numer zamówienia klienta, miejsca i dni załadunku i rozładunku, waga. Przy jego wierszu w banku stoi alert „Przyjęte w Transporeonie, brak w TMS”. Prezlecenie przyjmuje człowiek jak każde inne — nic nie idzie samo do TMS ani VIA.',
  audience: ['CS', 'Administracja', 'administrator'],
  presentationItems: ['S-04.11-02'],
  steps: [
    {
      route: '/transporeon',
      target: 'transporeon-filter-missing',
      title: 'Brak w TMS — prezlecenie',
      description:
        'W widoku „Brak w TMS” przy transporcie stoi odnośnik do prezlecenia ze źródłem Transporeon. Bez tej funkcji transport jest tylko oznaczony.',
      action: 'Otwórz „Transporeon” w menu (grupa „Administracja”) i kliknij filtr „Brak w TMS”.',
      recorder: { account: 'admin', actions: [{ kind: 'click', target: 'transporeon-filter-missing' }] },
    },
  ],
};
